/* eslint-disable */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from '../ui/dialog'

import { Button } from '../ui/button'

import tick from '../../assets/SVGS/success.gif'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { removeToken } from '../../utils/AuthUtil'
import { useNavigate } from 'react-router-dom'

const KycPopups = () => {
  const { isOpen, onClose, type, data } = useModal()
  const { severity, title, message, handleRedirect } = data
  const navigate = useNavigate()
  const isModalOpen = isOpen && type === 'openKycPopup'

  // user_cancelled
  // error
  // auto_approved
  // auto_declined
  // needs_review

  const handleLogout = () => {
    removeToken()
    navigate('/login')
  }

  const handleContinue = () => {
    onClose(), handleRedirect()
  }

  const kycImages = {
    user_cancelled: 'kyc-cancel.svg',
    auto_approved: 'kyc-updated.svg',
    auto_declined: 'kyc-declined.svg',
    failure: 'kyc-error.svg',
    needs_review: 'kyc-updated.svg',
  }

  return (
    <>
      {severity === 'auto_approved' && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center p-5 w-full max-w-[334px] min-h-[348px] rounded-xl'
            style={{
              background:
                severity === 'auto_approved'
                  ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #7EDD65 0%, #368421 100%)'
                  : severity === 'info'
                  ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #DD9365 0%, #843C21 100%)'
                  : 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #6597DD 0%, #213784 100%)',
            }}
          >
            <DialogHeader>
              <img src={tick} alt={severity} className='h-30 w-30 mx-auto' />

              <DialogTitle className='font-DMSans text-center font-semibold text-xl text-white text-wrap leading-7 tracking-[-0.04em]'>
                {data && title}
              </DialogTitle>
              <DialogDescription className='font-DMSans text-center font-normal text-sm text-white text-wrap leading-5'>
                {data && !data?.isKycPhUpdate && message}

                {data?.isKycPhUpdate && (
                  <div className='flex flex-col justify-center items-center space-x-1'>
                    <p>Your login number updated</p>
                    <p className='px-2 py-1 rounded-sm bg-white text-black-400 font-semibold'>
                      {data?.kycPhoneNumber}
                    </p>
                    <p> Use this number for your future login</p>
                  </div>
                )}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className='justify-center flex-row mt-3'>
              <DialogClose
                onClick={() => handleLogout()}
                style={{ background: '#FFFFFF3D' }}
                className='text-white text-sm min-w-[182px] rounded-xl py-3 px-6 font-medium'
              >
                Logout
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {['auto_declined', 'user_cancelled', 'needs_review', 'failure'].includes(severity) && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center px-8 py-10 w-full max-w-[334px] min-h-[334px] rounded-xl'
            showclose={severity !== 'needs_review' ? true : false}
          >
            <DialogHeader>
              <img
                src={`${env.SVGS}/${kycImages[severity]}`}
                alt='KYC Cancel'
                className='h-12 w-12 mx-auto mb-8'
              />

              <DialogTitle className='font-DMSans text-center font-semibold text-xl text-black-500 text-wrap leading-7 tracking-[-0.04em]'>
                {data && title}
              </DialogTitle>
              <DialogDescription className='font-DMSans text-center font-normal text-sm text-black-400 text-wrap leading-5'>
                {data && message}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className='justify-center flex-row'>
              {severity !== 'needs_review' ? (
                <Button
                  onClick={handleContinue}
                  className='w-[182px] py-3 px-6 rounded-xl mt-4 text-sm font-medium'
                >
                  Retry KYC
                </Button>
              ) : (
                <Button onClick={handleContinue} className='w-[182px] py-3 px-6 rounded-xl mt-4'>
                  Back to home
                </Button>
              )}
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
export default KycPopups
